// modules
import { useCallback, useEffect, useState } from "react";

import { Form } from "antd";

// service calls
import { fetchUserOffer, updateOffers } from "services/api/offerUpdate";
// components
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// constants and types

import { FormInstance } from "antd/es/form/Form";

import dayjs from "dayjs";

// for dayjs

import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(weekday);
dayjs.extend(localeData);
type AdhocReportPropTypes = {
	findOfferSubmit: () => void;
	updateOfferSubmit: () => void;
	resetFields: () => void;
	codeCountError: boolean;
	loading: boolean;
	form: FormInstance;
	cardNumber: string;
	member?: boolean;
	// receipt?: string;
	offer?: SelectObject;
	offerLabel?: string;
	fetchOfferData: ActiveVoucherList[];
	foundOffers: boolean;
	startDate: string;
	voucherNo: string;
	editTitle: string;
	editSubtitle: string;
	endDate: string;
	editOffer: boolean;
	foundButtonFindOffersEnable: boolean;
	unEditFoundOffers: boolean;
	remarks: string;
	offerSelect: SelectObject[];
	editData: any[];
	setEditData: (s: string[]) => void;
	selectedItems: any[];
	handleOffer: (s: SelectObject) => void;
	handleRemarks: (s: string) => void;
	goBack?: () => void;
	handleCardNumber: (s: string) => void;
	showModal: (s: string) => void;
	editOfferData: () => void;
	handleEndDate: (s: string) => void;
	handleStartDate: (s: string) => void;
	handleCheckboxChange: (e: CheckboxEvent, isSelectAll?: boolean) => void;
	checkedItems: { [key: string]: boolean };
	areAllItemsSelected: () => boolean;
};

interface SelectObject {
	label: string;
	value: string;
	key: string;
}

interface ActiveVoucherList {
	acquired_date: string;
	end_date: string;
	offer_id: string;
	start_date: string;
	voucher_internal_title: string;
	voucher_no: string;
	voucher_type_code: string;
	voucher_type_name: string;
}

interface CheckboxEvent {
	target: {
		checked: boolean;
		"data-props": ActiveVoucherList | null; // Allow null for select all case
	};
}

export function useOfferUpdatePage(): AdhocReportPropTypes {
	const [form] = Form.useForm();

	const [loading] = useState<boolean>(false);
	const [codeCountError, setCodeCountErr] = useState<boolean>(false);
	const [foundOffers, setFoundOffers] = useState<boolean>(false);
	const [cardNumber, setCardNumber] = useState<string>("");
	const [offer, setOffer] = useState<SelectObject>();
	const [offerLabel, setOfferlabel] = useState<string>();
	const [fetchOfferData, setFetchOfferData] = useState<ActiveVoucherList[]>([]);
	const [fetchOfferDataHolder, setFetchOfferDataHolder] = useState<ActiveVoucherList[]>([]);
	const [remarks, setRemarks] = useState<string>("");
	const [offerSelect, setOfferSelect] = useState<SelectObject[]>([]);
	const [editOffer, setEditOffer] = useState<boolean>(false);
	const [foundButtonFindOffersEnable, setFoundButtonFindOffersEnable] = useState<boolean>(false);
	const [unEditFoundOffers, setUnEditFoundOffers] = useState<boolean>(false);
	const [startDate, setStartDate] = useState<string>("");
	const [endDate, setEndDate] = useState<string>("");
	const [editTitle, setEditTitle] = useState<string>("Offer Update");
	const [editSubtitle, setEditSubtitle] = useState<string>("Find and update offers to active members and non-members.");
	const [voucherNo] = useState<string>("");
	const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
	const [editData, setEditData] = useState<any[]>([]);
	const [selectedItems, setSelectedItems] = useState<any[]>([]);

	useEffect(() => {
		if (editOffer) {
			setEditTitle("Edit");
			setEditSubtitle("Find and update offers to active members and non-members.");
		} else {
			setEditTitle("Offer Update");
			setEditSubtitle("Select one or more offers to update.");
		}

		if (!foundOffers && !editOffer) {
			setFoundButtonFindOffersEnable(true);
		} else {
			setFoundButtonFindOffersEnable(false);
		}

		if (foundOffers && !editOffer) {
			setUnEditFoundOffers(true);
		} else {
			setUnEditFoundOffers(false);
		}
	});
	const handleCardNumber = useCallback(
		(num: string) => {
			setCardNumber(num);
			if (!num) {
				setCodeCountErr(true);
			}
			setCodeCountErr(false);
		},
		[cardNumber]
	);

	const handleRemarks = useCallback(
		(val: string) => {
			setRemarks(val);
		},
		[remarks]
	);

	const goBack = () => {
		setEditOffer(false);
	};

	const handleStartDate = useCallback(
		(dateString: string) => {
			setStartDate(dateString);
		},
		[startDate]
	);

	const handleEndDate = useCallback(
		(dateString: string) => {
			setEndDate(dateString);
		},
		[endDate]
	);

	const handleOffer = useCallback(
		(val: SelectObject) => {
			setOffer(val);

			const filterData: any = fetchOfferDataHolder?.filter((x: any) => x?.offer_id === val);
			const findLabel: any = offerSelect?.find((x: any) => x?.value === val);

			setOfferlabel(findLabel?.label);
			setFetchOfferData([]);
			setFetchOfferData(filterData);
			setEditData([]);
			setSelectedItems([]);
		},
		[setOffer, fetchOfferData]
	);

	const areAllItemsSelected = useCallback((): boolean => {
		if (!fetchOfferData || fetchOfferData.length === 0) return false;
		return fetchOfferData.every((item) => checkedItems[item.voucher_no]);
	}, [fetchOfferData, checkedItems]);

	const handleCheckboxChange = (e: CheckboxEvent, isSelectAll = false) => {
		if (isSelectAll) {
			// Handle select all case
			const newCheckedState = e.target.checked;
			const newCheckedItems: { [key: string]: boolean } = {};
			const newSelectedItems: ActiveVoucherList[] = [];
			const newEditData: string[] = [];

			fetchOfferData?.forEach((item: ActiveVoucherList) => {
				newCheckedItems[item.voucher_no] = newCheckedState;
				if (newCheckedState) {
					newSelectedItems.push(item);
					newEditData.push(item.voucher_no);
				}
			});

			setCheckedItems(newCheckedItems);
			setSelectedItems(newSelectedItems);
			setEditData(newEditData);
		} else {
			// Handle individual checkbox case
			const item = e.target["data-props"] as ActiveVoucherList;
			const voucherNo = item.voucher_no;

			if (e.target.checked) {
				setEditData((list: string[]) => [...(list || []), voucherNo]);
				setSelectedItems((list: ActiveVoucherList[]) => [...(list || []), item]);
			} else {
				setEditData((list: string[]) => list?.filter((currentItem) => currentItem !== voucherNo) || []);
				setSelectedItems((list: ActiveVoucherList[]) => list?.filter((currentItem) => currentItem.voucher_no !== voucherNo) || []);
			}

			setCheckedItems((prev) => ({
				...prev,
				[voucherNo]: e.target.checked
			}));
		}
	};

	const resetFields = () => {
		setRemarks("");
		setCardNumber("");
		setOfferSelect([]);
		form.setFieldValue("offer", offerSelect[0]);
		form.setFieldValue("cardNumber", "");
		setEditData([]);
		setSelectedItems([]);
		setFoundOffers(false);
		setEditOffer(false);
		setCheckedItems({});
		setCodeCountErr(false);

		showModal("All Fields has been cleared");
	};
	const showModal = (title: string, error = false) => {
		CountDownModal({
			timer: 3,
			title,
			errorIcon: error
		});
	};
	const updateOfferSubmit = async () => {
		const errorMessages: string[] = [];

		const errorFlags = {
			remarks: !remarks,
			startDate: !startDate,
			endDate: !endDate
		};
		if (errorFlags.startDate) {
			setCodeCountErr(true);
			errorMessages.push("Start Date field is required.");
		}
		if (errorFlags.endDate) {
			setCodeCountErr(true);
			errorMessages.push("End Date field is required.");
		}
		if (errorFlags.remarks) {
			setCodeCountErr(true);
			errorMessages.push("Remarks field is required.");
		}

		if (errorMessages.length > 0) {
			showModal(errorMessages[0], true);
			return;
		}

		const payload = {
			card_no: cardNumber,
			remarks,
			start_date: startDate,
			end_date: endDate,
			user_offer_ids: editData
		};
		const wrong = "Something went wrong.";
		try {
			const { data: reportsData } = await updateOffers(payload);
			const { errors, data } = reportsData;

			if (!data) {
				showModal(errors[0].message || wrong, true);
				return;
			}

			showModal("CSV report successfully generated.");
			window.open(data.file_url, "_blank");
			resetFields();
			setEditOffer(false);
		} catch (e: any) {
			showModal(e.response?.data?.errors[0]?.message || wrong, true);
		}
	};
	const editOfferData = (/* data: any */) => {
		if (editData.length <= 0) {
			showModal("Select at least 1 offer to edit.", true);
			return;
		}
		setEditOffer(true);
	};
	const findOfferSubmit = async () => {
		const payload = {
			card_no: cardNumber
		};
		setFetchOfferData([]);

		setOfferlabel(offer?.label);
		const showModal = (title: string, error = false) => {
			CountDownModal({
				timer: 3,
				title,
				errorIcon: error
			});
		};
		const requiredMsg = "Please fill all required fields.";
		const wrong = "Something went wrong.";
		if (!cardNumber) {
			setCodeCountErr(true);
			showModal(requiredMsg, true);
			return;
		}
		try {
			const { data: reportsData } = await fetchUserOffer(payload);

			const { errors, data } = reportsData;

			if (!data) {
				showModal(errors[0].message || wrong, true);
				return;
			}
			const offerData: SelectObject[] = [];
			offerData.push({
				label: "< Select an offer >",
				value: "",
				key: "0"
			});
			data.voucher_summary.map((res: any, i: number) => {
				offerData.push({
					label: res.voucher_type_name,
					value: res.offer_id,
					key: `${res.offer_id}-${i}`
				});
			});

			setOfferSelect(offerData);
			setOffer(offerData[0]);

			setFetchOfferData([]);
			setFetchOfferDataHolder(data.active_voucher_lists);

			setFoundOffers(true);
			setCodeCountErr(false);
		} catch (e: any) {
			showModal(e.response?.data?.errors[0]?.message || wrong, true);
		}
	};

	return {
		loading,
		form,
		codeCountError,
		handleOffer,
		unEditFoundOffers,
		cardNumber,
		foundOffers,
		offerLabel,
		handleCardNumber,
		handleCheckboxChange,
		setEditData,
		checkedItems,
		handleRemarks,
		voucherNo,
		offer,
		offerSelect,
		fetchOfferData,
		remarks,
		findOfferSubmit,
		updateOfferSubmit,
		goBack,
		handleStartDate,
		handleEndDate,
		editOfferData,
		showModal,
		resetFields,
		editTitle,
		editSubtitle,
		selectedItems,
		startDate,
		endDate,
		editOffer,
		editData,
		foundButtonFindOffersEnable,
		areAllItemsSelected
	};
}
